import type { QuickStartStep } from '../types/help-center.types';

export const quickStartSteps: QuickStartStep[] = [
  {
    number: 1,
    title: 'Configurar los datos maestros',
    description:
      'La información base de tu empresa: divisas, tipos de cambio, líneas de negocio y países.',
    details: [
      'Agregá las divisas que manejás (USD, BOB, EUR…) y sus tipos de cambio.',
      'Armá tus líneas de negocio en 3 niveles: Sector, Vertical y Marca.',
      'Registrá los países donde operás.',
      'Si importás, buscá las partidas arancelarias en Comercia › Asistente arancelario.',
    ],
    link: '/master-data',
  },
  {
    number: 2,
    title: 'Crear un modelo de precio',
    description:
      'Cómo se calculan tus precios: variables, fórmulas y, si hace falta, tablas de búsqueda.',
    details: [
      'Creá el modelo con su nombre, un código único, la descripción y el tipo.',
      'En la ficha del modelo agregá variables: número, moneda, porcentaje, calculada y otras.',
      'Las fórmulas usan los códigos de otras variables.',
      'Hay variables globales (una por cotización) y por ítem (una por línea).',
      'Si las necesitás, sumá tablas de búsqueda y precios por volumen.',
    ],
    link: '/pricing-models',
  },
  {
    number: 3,
    title: 'Registrar los materiales',
    description: 'Tu catálogo de productos y servicios, con la información arancelaria.',
    details: [
      'Registrá cada material con su código interno y externo.',
      'Asigná la partida arancelaria a los que se importan.',
      'Las tasas arancelarias guardan su historial con fecha de vigencia.',
      'Con el catálogo ordenado, armar una cotización es elegir de una lista.',
    ],
    link: '/materials',
  },
  {
    number: 4,
    title: 'Crear tu primera cotización',
    description: 'Una cotización con una o varias secciones, cada una con su modelo de precio.',
    details: [
      'Cargá los datos del cliente: nombre, correo y teléfono.',
      'Elegí la línea de negocio, el país y la moneda.',
      'Agregá secciones con distintos modelos (por ejemplo, Software, Hardware y Soporte).',
      'Completá las variables globales y las de cada ítem.',
      'Antes de enviarla, mirá la cascada de costos y el margen.',
    ],
    link: '/quotes/new',
  },
  {
    number: 5,
    title: 'Gestionar las aprobaciones',
    description: 'Revisá, aprobá o pedí ajustes en las cotizaciones de tu equipo.',
    details: [
      'En Cotiza › Aprobaciones ves lo que espera tu firma y de quién depende cada una.',
      'Abrí el detalle de cada cotización: cliente, ítems, margen y precio.',
      'Aprobá, rechazá o pedí un ajuste; al rechazar o pedir un ajuste, el comentario es obligatorio.',
      'Quien la creó recibe un aviso cuando hay que cambiar algo.',
      'El ida y vuelta sigue hasta que la cotización se aprueba o se rechaza.',
    ],
    link: '/approvals',
  },
];
